
export default function Head({ name }) {

    return (
        <div className="headList center textBoldHight">
            {
                name
            }
        </div>
    );
}